import * as Icons from '@rsuite/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faList, faBoltLightning } from '@fortawesome/free-solid-svg-icons'
import SvgLoader from "@client/components/SvgLoader";

const DownloadIcon = () => <FontAwesomeIcon icon={faDownload} />
const ListIcon = () => <FontAwesomeIcon icon={faList} />
const QueryIcon = () => <FontAwesomeIcon icon={faBoltLightning} />
const OutTemplateListIcon = Icons.Copy
const InDataListIcon = Icons.Storage
const ConverterListIcon = Icons.Conversion
const RunMappingIcon = Icons.ChangeList
const ExportListIcon = Icons.FileDownload
const ProjectIcon = Icons.Project
const PeoplesIcon = Icons.Peoples
const SettingsIcon = Icons.Gear
const UserIcon = Icons.UserChange
const SearchIcon = Icons.Search
const SubscriptionIcon = Icons.History
const HelpIcon = Icons.HelpOutline
const TenantIcon = () => <SvgLoader file="/images/tenant.svg" />

export {
    ProjectIcon,
    PeoplesIcon,
    OutTemplateListIcon,
    InDataListIcon,
    ConverterListIcon,
    RunMappingIcon,
    ExportListIcon,
    SettingsIcon,
    SubscriptionIcon,
    DownloadIcon,
    ListIcon,
    UserIcon,
    QueryIcon,
    SearchIcon,
    HelpIcon,
    TenantIcon,
}
